var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import BlockButton from './Fields/BlockButton';
import BlockLink from './Fields/BlockLink';
import Checkbox from './Fields/Checkbox';
import CheckboxList from './Fields/CheckboxList';
import CompactRow from './Fields/CompactRow';
import { ControlLabel } from 'react-bootstrap';
import DatePicker from './Fields/DatePicker';
import DisableText from './Fields/DisableText';
import Dropzone from './Fields/Dropzone';
import Email from './Fields/Email';
import Errors from './Fields/Errors';
import Exception from './Fields/Exception';
import ExpandIfAge from './Fields/ExpandIfAge';
import ExpandIfX from './Fields/ExpandIfX';
import ExpandIfYes from './Fields/ExpandIfYes';
import ExpandableForm from './Fields/ExpandableForm';
import FormBuilder from './FormBuilder';
import Header from './Header/Header';
import HeightDisplay from './Fields/HeightDisplay';
import HeightInches from './Fields/HeightInches';
import Image from './Fields/Image';
import Money from './Fields/Money';
import MultiSelect from './Fields/MultiSelect';
import Number from './Fields/Number';
import Password from './Fields/Password';
import PropTypes from 'prop-types';
import RadioList from './Fields/RadioList';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import Select from './Fields/Select';
import ShortText from './Fields/ShortText';
import Signature from './Fields/Signature';
import Slider from './Fields/Slider';
import SmallButton from './Fields/SmallButton';
import Text from './Fields/Text';
import TextArea from './Fields/TextArea';
import TextBox from './Fields/TextBox';
import WeightDisplay from './Fields/WeightDisplay';
import WeightPounds from './Fields/WeightPounds';
import YesNo from './Fields/YesNo';

function FieldBuilder(_ref, context) {
  var field = _ref.field;
  var customFields = context.customFields,
      form = context.form;


  switch (field.type) {
    case 'block-button':
      return React.createElement(BlockButton, field);

    case 'block-link':
      return React.createElement(BlockLink, field);

    case 'center-paragraph':
      return React.createElement(
        'p',
        { className: 'text-center' },
        field.text
      );

    case 'checkbox':
      return React.createElement(Checkbox, _extends({ inline: true }, field));

    case 'checkbox-list':
      return React.createElement(CheckboxList, field);

    case 'compact-row':
      return React.createElement(CompactRow, field);

    case 'date-picker':
      return React.createElement(DatePicker, field);

    case 'disable-text':
      return React.createElement(DisableText, field);

    case 'dropzone':
      return React.createElement(Dropzone, field);

    case 'email':
      return React.createElement(Email, field);

    case 'errors':
      return React.createElement(Errors, _extends({}, field, { errors: form.getErrors() }));

    case 'exception':
      return React.createElement(Exception, _extends({}, field, { exception: form.get('exception') }));

    case 'expand-if-age':
      return React.createElement(ExpandIfAge, field);

    case 'expand-if-x':
      return React.createElement(ExpandIfX, field);

    case 'expand-if-yes':
      return React.createElement(ExpandIfYes, field);

    case 'expandable-form':
      return React.createElement(ExpandableForm, field);

    case 'form':
      return React.createElement(
        'div',
        null,
        field.label && React.createElement(
          ControlLabel,
          null,
          field.label
        ),
        React.createElement(FormBuilder, _extends({}, form.props, field))
      );

    case 'header':
      return React.createElement(
        Header,
        null,
        React.createElement(
          'h1',
          null,
          field.heading
        ),
        React.createElement(
          'h2',
          null,
          field.subheading
        )
      );

    case 'heading':
      return React.createElement(
        'h2',
        null,
        field.text
      );

    case 'height-display':
      return React.createElement(HeightDisplay, field);

    case 'height-inches':
      return React.createElement(HeightInches, field);

    case 'horizontal-rule':
      return React.createElement('hr', null);

    case 'image':
      return React.createElement(Image, field);

    case 'markdown':
      return React.createElement(ReactMarkdown, _extends({ className: 'Text-Spacer' }, field));

    case 'money':
      return React.createElement(Money, field);

    case 'multi-select':
      return React.createElement(MultiSelect, field);

    case 'number':
      return React.createElement(Number, field);

    case 'page-break':
      return React.createElement('hr', { className: 'Page-Break' });

    case 'paragraph':
      return React.createElement(
        'p',
        { className: 'Text-Spacer' },
        field.text
      );

    case 'password':
      return React.createElement(Password, field);

    case 'radio-list':
      return React.createElement(RadioList, field);

    case 'select':
      return React.createElement(Select, field);

    case 'short-text':
      return React.createElement(ShortText, field);

    case 'signature':
      return React.createElement(Signature, field);

    case 'slider':
      return React.createElement(Slider, field);

    case 'small-button':
      return React.createElement(SmallButton, field);

    case 'subheading':
      return React.createElement(
        'h3',
        null,
        field.text
      );

    case 'text':
      return React.createElement(Text, field);

    case 'textarea':
      return React.createElement(TextArea, field);

    case 'text-box':
      return React.createElement(TextBox, field);

    case 'weight-display':
      return React.createElement(WeightDisplay, field);

    case 'weight-pounds':
      return React.createElement(WeightPounds, field);

    case 'yes-no':
      return React.createElement(YesNo, field);

    default:
      if (customFields && customFields[field.type]) {
        var custom = customFields[field.type];
        return custom(field, context);
      }

      console.error('Could not create field of type: ' + field.type);
      return null;
  }
}

FieldBuilder.contextTypes = {
  customFields: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired
};

FieldBuilder.propTypes = process.env.NODE_ENV !== "production" ? {
  field: PropTypes.object.isRequired
} : {};

export default FieldBuilder;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/FieldBuilder.js
// module id = 259
// module chunks = 0